import React, { useEffect } from "react";
import "./App.css";
import Routing from "./routes";

// import "./assets/css/materialdesignicons.min.css";
import "./assets/css/pe-icon-7-stroke.min.css";
import "./assets/css/bootstrap.min.css";
import ComingSoon from "./ComingSoon";
import Maintenance from "./Maintenance";

const App = () => {
  const isProduction = window.location.hostname === "www.theendlessmoment.com";

  useEffect(() => {
    const scrollToHashElement = () => {
      const hash = window.location.hash;
      if (hash) {
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);

        if (element) {
          const scrollToElement = () => {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => window.scrollBy(0, 0), 1000);
          };

          scrollToElement();

          setTimeout(scrollToElement, 1000);
        }
      }
    };

    if (document.readyState === "complete") {
      scrollToHashElement();
    } else {
      window.addEventListener("load", scrollToHashElement);
    }

    return () => window.removeEventListener("load", scrollToHashElement);
  }, []);

  // if (isProduction) {
  //   return <ComingSoon />;
  // }

  // return <Maintenance />;

  return (
    <React.Fragment>
      <Routing />
    </React.Fragment>
  );
};

export default App;
